import { useState, useEffect, useRef } from 'react';
import { WS_BASE_URL } from '../services/api';

export const useWebSocket = () => {
  const [isConnected, setIsConnected] = useState(false);
  const [messages, setMessages] = useState([]);
  const ws = useRef(null);
  const reconnectTimeout = useRef(null);
  
  // Get token directly from localStorage
  const idToken = localStorage.getItem('idToken');

  useEffect(() => {
    if (!idToken || !WS_BASE_URL) {
      if (ws.current) {
        ws.current.close();
      }
      return;
    }

    const connect = () => {
      // Connect to API Gateway WebSocket URL and pass token in query
      ws.current = new WebSocket(`${WS_BASE_URL}?token=${idToken}`);

      ws.current.onopen = () => {
        console.log('WebSocket Connected');
        setIsConnected(true);
        if (reconnectTimeout.current) {
          clearTimeout(reconnectTimeout.current);
          reconnectTimeout.current = null;
        }
      };

      ws.current.onclose = (event) => {
        console.log('WebSocket Disconnected', event);
        setIsConnected(false);
        // Ensure we only try to reconnect if the token is still valid.
        if (idToken) {
           reconnectTimeout.current = setTimeout(() => {
             console.log('Attempting to reconnect WebSocket...');
             connect();
           }, 5000); // 5 seconds reconnect delay
        }
      };

      ws.current.onerror = (error) => {
        console.error('WebSocket Error:', error);
      };

      ws.current.onmessage = (event) => {
        try {
          const message = JSON.parse(event.data);
          console.log('WebSocket Message Received:', message);
          setMessages(prev => [...prev, message]);
          
          // Emit a custom browser event so components can listen easily
          const customEvent = new CustomEvent('ws-message', { detail: message });
          window.dispatchEvent(customEvent);
          
        } catch (error) {
          console.error('Error parsing WebSocket message:', error);
        }
      };
    };

    connect();

    return () => {
      if (ws.current) {
        // Clear close handler so it doesn't trigger reconnect on unmount
        ws.current.onclose = null; 
        ws.current.close();
      }
      if (reconnectTimeout.current) {
        clearTimeout(reconnectTimeout.current);
      }
    };
  }, [idToken]);

  return { isConnected, messages };
};
